import axios from "axios";
import settings from "../settings";

export const setDefaultBaseUrl = () => axios.defaults.baseURL = settings.apiBaseUrl;